import React from 'react';
import { Modal, ModalHeader, ModalBody, Table, Badge, Button } from 'reactstrap';
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';

const renderValue = (val) => {
    if (val === null || val === undefined) return <span className="text-muted fst-italic">Vazio</span>;
    if (typeof val === 'boolean') return val ? <Badge color="success">Sim</Badge> : <Badge color="danger">Não</Badge>;
    if (typeof val === 'object') {
        // Ponto de atenção para Timestamp do backend se viajou
        if (val.seconds) {
            return format(new Date(val.seconds * 1000), 'dd/MM/yyyy HH:mm', { locale: ptBR });
        }
        return <pre className="mb-0 bg-light p-1 rounded font-size-11">{JSON.stringify(val, null, 2)}</pre>;
    }
    return String(val);
};

const AuditDetailsModal = ({ isOpen, toggle, log }) => {
    if (!log || !log.details) return null;

    const changes = Object.entries(log.details);

    return (
        <Modal isOpen={isOpen} toggle={toggle} size="lg" centered scrollable>
            <ModalHeader toggle={toggle} className="border-bottom-0 pb-0">
                <h5 className="mb-1">Detalhes da Alteração</h5>
                <p className="text-muted font-size-13 mb-0">
                    {log.entityName || log.module} - {log.action} por {log.userName}
                </p>
            </ModalHeader>
            <ModalBody>
                <div className="table-responsive">
                    <Table className="table-bordered table-sm align-middle font-size-13 mb-0">
                        <thead className="table-light">
                            <tr>
                                <th>Campo Alterado</th>
                                <th style={{ width: '35%' }}>Valor Anterior</th>
                                <th style={{ width: '35%' }}>Novo Valor</th>
                            </tr>
                        </thead>
                        <tbody>
                            {changes.map(([field, data], idx) => (
                                <tr key={idx}>
                                    <td className="fw-medium text-muted">{field}</td>
                                    <td className="text-danger bg-danger bg-opacity-10">
                                        {renderValue(data?.from)}
                                    </td>
                                    <td className="text-success bg-success bg-opacity-10">
                                        {renderValue(data?.to)}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </div>
            </ModalBody>
            <div className="modal-footer border-top-0 pt-0">
                <Button color="secondary" onClick={toggle} size="sm">
                    Fechar
                </Button>
            </div>
        </Modal>
    );
};

export default AuditDetailsModal;
